import { actionGenerator, IReduxAction } from '../../utils/actions';

export const CHANGE_CURRENT_OVER_PACKAGE_BET = 'AUCTION :: CHANGE_CURRENT_OVER_PACKAGE_BET';

export type TChangeCurrentOverPackageBetAction = IReduxAction<typeof CHANGE_CURRENT_OVER_PACKAGE_BET, number>;

export const changeCurrentOverPackageBet = actionGenerator<typeof CHANGE_CURRENT_OVER_PACKAGE_BET, number>(
  CHANGE_CURRENT_OVER_PACKAGE_BET,
);
